






























import Vue from "vue";
import { mapMutations, mapGetters, mapActions } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default Vue.extend({
  name: "PickDayCSVModal",
  components: {
    DatePicker
  },
  props: {
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      time: null,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
          months: [
            "Tháng 1",
            "Tháng 2",
            "Tháng 3",
            "Tháng 4",
            "Tháng 5",
            "Tháng 6",
            "Tháng 7",
            "Tháng 8",
            "Tháng 9",
            "Tháng 10",
            "Tháng 11",
            "Tháng 12"
          ],

          monthsShort: [
            "Tháng 1",
            "Tháng 2",
            "Tháng 3",
            "Tháng 4",
            "Tháng 5",
            "Tháng 6",
            "Tháng 7",
            "Tháng 8",
            "Tháng 9",
            "Tháng 10",
            "Tháng 11",
            "Tháng 12"
          ],

          weekdays: [
            "Chủ Nhật",
            "Thứ Hai",
            "Thứ Ba",
            "Thứ Tư",
            "Thứ Năm",
            "Thứ Sáu",
            "Thứ Bảy"
          ],

          weekdaysShort: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],

          weekdaysMin: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"]
        },
        monthBeforeYear: false
      }
    };
  },
  methods: {
    async handleSubmit() {
      if (!this.time || !this.time[0]) {
        await this.getAllCSV(this.type);
      } else {
        await this.getCSV({
          type: this.type,
          start: this.time[0],
          end: this.time[1]
        });
        this.time = null;
      }
    },
    ...mapMutations({
      changeShow: "pickDayCSV/changeShow"
    }),
    ...mapActions({
      getCSV: "pickDayCSV/getCSV",
      getAllCSV: "pickDayCSV/getAllCSV"
    })
  },
  computed: {
    ...mapGetters({
      showModal: "pickDayCSV/isShow",
      onDownload: "pickDayCSV/onDownload"
    })
  }
});
